<template>
  <v-app id="bg_Portal">
    <v-layout row wrap align-center justify-center>
      <v-flex lg8 xs10>
        <v-layout row wrap justify-center fill-height align-center>
          <v-flex xs8 sm8 md8 lg8>
            <v-card-text class="text-center">
              <img src="@/assets/img/loadingPage.gif" width="100%" />
            </v-card-text>
          </v-flex>
          <v-flex xs12 sm12 md12 class="ma-2 text-center">
            <v-card-text class="text-center">
              <h2 style="font-weight: normal">
                {{ $t("landingpage_404.title") }}
              </h2>
              <br />
              <v-btn color="#077893" dark Depressed to="/" class="elevation-0">
                {{ $t("landingpage_404.subTitle") }}</v-btn
              >
            </v-card-text>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
export default {};
</script>

<style scoped>
#bg_Portal {
  background: #ddf7ff !important;
  /* background: linear-gradient(to left,#4ECDC4 0%, #808080 100%); */
  /* background: linear-gradient(to right,#4CA1AF 0%, #C4E0E5 100%); */
  font-family: "Sarabun", sans-serif;
  /* background: linear-gradient(to right,#00467F 0%, #A5CC82 100%); */
}
</style>
